import moment from "moment";
import {
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
  Tooltip,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

type Props = {
  kiosk: {
    kioskId: string;
    kioskLocation: string;
    lastDataRefreshTime: number;
    lastEventTime: number;
  };
};
const KioskHealthCard = ({ kiosk }: Props) => {
  const currentTime = moment();
  const lastDataRefreshTime = moment(kiosk.lastDataRefreshTime);
  const lastEventTime = moment(kiosk.lastEventTime);

  const timeDiffMins = currentTime.diff(lastEventTime, "minutes");
  const updateTimeDiffMins = currentTime.diff(lastDataRefreshTime, "minutes");

  const isOffline = timeDiffMins > 30 || kiosk.lastDataRefreshTime === 0;

  return (
    <Card
      elevation={3}
      sx={{ borderRadius: 3, height: 220, position: "relative" }}
    >
      <CardHeader
        titleTypographyProps={{ variant: "h6" }}
        title={`Kiosk ${kiosk.kioskId}`}
        subheader={kiosk.kioskLocation}
        action={
          <Chip
            label={isOffline ? "OFFLINE" : "ONLINE"}
            color={isOffline ? "error" : "success"}
            size="small"
          />
        }
      />
      <CardContent>
        <Stack spacing={1.2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <AccessTimeIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              Last Data Update: {updateTimeDiffMins} minutes ago
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <AccessTimeIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              Last Connect: {timeDiffMins} minutes ago
            </Typography>
          </Stack>
          <Box mt={1}>
            {isOffline ? (
              <Stack direction="row" spacing={1} alignItems="center">
                <ErrorOutlineIcon color="error" />
                <Typography variant="body2" color="error.main">
                  Attention required
                </Typography>
              </Stack>
            ) : (
              <Stack direction="row" spacing={1} alignItems="center">
                <CheckCircleOutlineIcon color="success" />
                <Typography variant="body2" color="success.main">
                  Healthy
                </Typography>
              </Stack>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default KioskHealthCard;
